import { render } from "./HeroSectionFive.vue?vue&type=template&id=1c80c899"
import script from "./HeroSectionFive.vue?vue&type=script&lang=js"
export * from "./HeroSectionFive.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__